/* template */
<template><div class="ticket-card"><div class="origin-ticket">原车次</div><div class="place-item">{{ticketInfo.pre_from_station_name}}<mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/ivL86njzlL1661939706068.png" class="arrow-right"></mpx-image>{{ticketInfo.pre_to_station_name}}<span :style='["font-size: 14px;color: #666666;margin-left:4px"] | transRpxStyle'>{{ticketInfo.pre_train_code}}</span></div><div class="time-item">{{ticketDate}}</div><div class="reason-item" v-if="(ticketInfo.reason)">改签原因：{{ticketInfo.reason}}</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4e3da240"}'>
  .origin-ticket
    width 44px
    height 14px
    background #F3F4F5
    border-radius 8px 1px 8px 1px
    font-family PingFangSC-Regular
    font-size 10px
    color #999999
    font-weight 400
    line-height 14px
    text-align center
    position absolute
    left 0px
    top 0px
  .ticket-card
    width calc(100% - 12px)
    background #FFF
    box-sizing border-box
    border-radius 8px
    padding-top 16px
    padding-left 12px
    padding-right 12px
    padding-bottom 12px
    position relative
  .arrow-right
    width 14px
    height 4px
    margin-bottom 4px
    margin-right 4px
    margin-left 4px
  .place-item
    font-family PingFangSC-Medium
    font-size 15px
    color #333
    font-weight 500
  .time-item
    font-family PingFangSC-Light
    font-size 12px
    color #333
    text-align left
    line-height 17px
    font-weight 300
    margin-top 4px
    margin-bottom 2px
  .reason-item
    font-family PingFangSC-Regular
    font-size 12px
    color #999
    text-align left
    line-height 17px
    font-weight 400
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4e3da240"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./change-ticket-card.mpx.js?isComponent&outputPath=components%2Fchange-ticket-card4e3da240%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-ticket-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fchange-ticket-card4e3da240%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4e3da240"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/change-ticket-card4e3da240/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
